module.exports = __webpack_public_path__ + "static/media/Finx-Tour.4ca0fcbd.mp4";